export class Crew {
    id = 0;
    name = '';
    crewEmployeeMemberships = [];
    crewEquipmentMemberships = [];
    colorHex = '';
    divisionId = 0;
    isInactive = false;
    crewLeadEmployeeId = null;
}
